const DAY_SECONDS = 24 * 60 * 60;

// validateUnixRange returns a user-facing error for an invalid bounded time range.
// 校验时间范围是否有效且没有超过接口允许的最大天数。
export function validateUnixRange(start: string | number, end: string | number, maxDays: number) {
  const startAt = Number(start);
  const endAt = Number(end);
  if (!Number.isFinite(startAt) || !Number.isFinite(endAt) || startAt <= 0 || endAt <= 0) {
    return "请选择有效时间";
  }
  if (startAt >= endAt) return "结束时间需晚于开始时间";
  if (endAt - startAt > maxDays * DAY_SECONDS) return `时间范围不能超过 ${maxDays} 天`;
  return "";
}

// toLocalDateTimeInput formats a Unix timestamp without throwing on an empty draft.
// 把 Unix 时间转成本地输入值，空值或非法值返回空字符串。
export function toLocalDateTimeInput(timestamp: string | number) {
  const value = Number(timestamp);
  if (!Number.isFinite(value) || value <= 0) return "";
  const date = new Date(value * 1000);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}

// localDateTimeToUnix converts a local datetime input into a safe Unix draft value.
// 把本地时间输入转成 Unix 字符串，清空输入时不产生 NaN。
export function localDateTimeToUnix(value: string) {
  if (!value) return "";
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? String(Math.floor(timestamp / 1000)) : "";
}
